import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { fetchData } from "../../../../helpers/getData/fetchData";
import { Loading } from "../../../generals/Loading";
import SendPushNotifications from "./SendPushNotifications";
import { useForm } from "../../../../../hooks";

export const GetUsers = ({ fundsList }) => {
  const { t } = useTranslation("global");

  const [userList, setuserList] = useState([]);

  const [formValues, handleInputChange] = useForm({
    clubFilter: ["Todos los clubs"],
    fundFilter: ["Sin filtro de fondo"],
    message: "",
    languageFilter: "Todos los idiomas",
  });

  useEffect(() => {
    fetchData(setuserList, `/user/getUsersWhitFund`, t);
  }, [t]);

  if (userList.length < 1) {
    return <Loading />;
  }

  if (userList.length > 0) {
    return (
      <SendPushNotifications
        formValues={formValues}
        handleInputChange={handleInputChange}
        userList={userList}
        fundsList={fundsList}
      />
    );
  }
};
